import { MuiThemeComponentsType } from '../types';

export default (): MuiThemeComponentsType['MuiInputBase'] => ({
  styleOverrides: {
    root: {
      borderRadius: 8,
    },
  },
});
